import { FunctionComponent as FC } from 'react';

import { List } from '@chakra-ui/react';
import { MBox } from './chakra';
import MText from './MText';

type MTooltipContentListProps = {
  listItems: string[];
  title?: string;
};

export const MTooltipContentList: FC<MTooltipContentListProps> = (
  props: MTooltipContentListProps,
) => {
  const { listItems, title } = props;

  return (
    <MBox maxW={180}>
      <MText
        border={0}
        pb={0}
        fontWeight="bold"
        color="tWhite.base"
        fontSize={12}
      >
        {title}
      </MText>
      <List.Root as="ul" ml="4">
        {listItems.map((msg, idx) => {
          return (
            <List.Item key={`msg-${idx}`}>
              <MText pt={0} color="tWhite.base" fontSize={12}>
                {msg}
              </MText>
            </List.Item>
          );
        })}
      </List.Root>
    </MBox>
  );
};
